import Link from "next/link";
import MainArticle from "./MainArticle";

import cx from "classnames";
import { FC } from "react";
import {
  AllBlogSectionsQuery,
  ArticlesBySectionQuery,
} from "services/datocms/generated";
import st from "./blog-homepage-content.module.scss";
import BlogFilter from "./BlogFilter";
import FeaturedArticle from "./FeaturedArticle";
import { useTranslationContext } from "context/translation";

export type BlogFilterCategory = {
  slug: string;
  filterText: string;
};

interface Props {
  sections: AllBlogSectionsQuery["allBlogSections"];
  selectedCategory?: AllBlogSectionsQuery["allBlogSections"][number] | null;
  filteredCategories?: BlogFilterCategory[];
  articles?: ArticlesBySectionQuery["allArticles"];
}

const BlogHomepageContent: FC<Props> = ({
  sections,
  selectedCategory,
  filteredCategories,
  articles,
}) => {
  const { homepage = "Homepage", blog = "Blog" } = useTranslationContext();

  return (
    <div className={cx(st.container, "container")}>
      <div className={st.breadcrumbContainer}>
        <Link href="/">{homepage}</Link>
        <p>{">"}</p>
        {!selectedCategory ? (
          <p>{blog}</p>
        ) : (
          <Link href="/blog">&nbsp;&nbsp;Blog</Link>
        )}
        {selectedCategory && (
          <>
            <p>{">"}</p>
            <p>{selectedCategory.title}</p>
          </>
        )}
      </div>
      <BlogFilter
        filterCategories={filteredCategories}
        selectedCategory={selectedCategory?.slug}
      />
      {sections.map((section, index) => {
        return (
          <div key={index} className={st.sectionContainer}>
            <h2 className={st.sectionTitle}>{section.title}</h2>
            <div>
              <MainArticle
                heroVisual={section.mainArticle?.heroVisual?.responsiveImage}
                slug={`${section.slug?.toLowerCase()}/${section.mainArticle?.slug?.toLowerCase()}`}
                title={section.mainArticleTitleText || ""}
                summary={section.mainArticleSummary?.value}
              />
              <div className={st.secondaryArticlesContainer}>
                {(articles ?? section.secondaryArticles).map((article) => (
                  <FeaturedArticle
                    key={article?.id}
                    heroVisual={article.heroVisual?.responsiveImage}
                    slug={`${section.slug?.toLowerCase()}/${article.slug?.toLowerCase()}`}
                    title={article?.title || ""}
                  />
                ))}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BlogHomepageContent;
